import registrationApi from 'api/rest/registration'
import { getActivationPageUrl } from 'utils'

export const startRegistrationFlowExistingCustomer = () => {
  registrationApi.redirectToSignIn({ returnUrl: getActivationPageUrl(), enableLogging: true })
}

export const startRegistrationFlow = (token: string) => {
  registrationApi.redirectToSignUp(token, { enableLogging: true })
}
